export type Locale = 'en' | 'es';

export const translations: Record<Locale, Record<string, string>> = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.skills': 'Skills',
    'nav.projects': 'Projects',
    'nav.contact': 'Contact',

    // Loader
    'loader.initializing': 'INITIALIZING NEURAL INTERFACE',
    'loader.loading': 'LOADING CONSCIOUSNESS',
    'loader.complete': 'SYSTEM READY',

    // Hero
    'hero.badge': 'SYSTEM ONLINE — PORTFOLIO 2027',
    'hero.greeting': 'FORWARD DEPLOYED ENGINEER',
    'hero.name': 'JUAN FABRICIO AGUIRRE TAMAYO',
    'hero.tagline': 'Bridging biological intelligence with artificial intelligence',
    'hero.scroll': 'SCROLL TO EXPLORE',

    // Thought Process
    'thoughts.title': 'THOUGHT PROCESS',
    'thoughts.subtitle': 'A lifetime of skills converging into a singular vision',
    'thoughts.prompt': 'Prompt Engineering',
    'thoughts.agri': 'Agricultural Engineering',
    'thoughts.drone': 'Drone Pilot',
    'thoughts.sales': 'General Sales',
    'thoughts.hockey': 'Hockey Player',
    'thoughts.skating': 'Skating Coach',
    'thoughts.ai': 'AI Development & LLM Agents',
    'thoughts.mcp': 'MCP Architecture',
    'thoughts.react': 'React + Vite',
    'thoughts.python': 'Python',
    'thoughts.web': 'HTML, CSS, JS',
    'thoughts.php': 'PHP',
    'thoughts.git': 'Advanced Git',

    // Character Journey
    'journey.title': 'THE JOURNEY',
    'journey.field': 'In the fields of Ecuador, learning to nurture life',
    'journey.drone': 'Taking flight - 500+ hours of drone operations',
    'journey.sales': 'Mastering the art of human connection through sales',
    'journey.hockey': 'Discipline and teamwork on the ice',
    'journey.skating': 'Teaching others to find their balance',
    'journey.code': 'Translating biological patterns into code',
    'journey.ai': 'Architecting the future with AI agents',

    // Skills
    'skills.title': 'TECHNICAL ARSENAL',
    'skills.categories.life': 'Life Skills',
    'skills.categories.tech': 'Technical Skills',
    'skills.categories.ai': 'AI & Modern Stack',

    // Projects
    'projects.title': 'PROJECT CASE STUDIES',
    'projects.subtitle': 'Real-world applications solving real problems',
    'projects.view': 'View Project',
    'projects.code': 'View Code',
    'projects.demo': 'Live Demo',
    'projects.featured': 'Featured',

    // Contact
    'contact.title': 'ESTABLISH CONNECTION',
    'contact.subtitle': 'Ready to build something extraordinary together',
    'contact.email': 'Email',
    'contact.github': 'GitHub',
    'contact.linkedin': 'LinkedIn',
    'contact.whatsapp': 'WhatsApp',
    'contact.message': 'Let\'s collaborate',

    // Footer
    'footer.rights': 'All rights reserved',
    'footer.built': 'Built with precision and passion',

    // Language
    'lang.switch': 'ES',
    'lang.current': 'EN',
  },
  es: {
    // Navigation
    'nav.home': 'Inicio',
    'nav.about': 'Sobre Mí',
    'nav.skills': 'Habilidades',
    'nav.projects': 'Proyectos',
    'nav.contact': 'Contacto',

    // Loader
    'loader.initializing': 'INICIALIZANDO INTERFAZ NEURAL',
    'loader.loading': 'CARGANDO CONCIENCIA',
    'loader.complete': 'SISTEMA LISTO',

    // Hero
    'hero.badge': 'SISTEMA EN LÍNEA — PORTAFOLIO 2027',
    'hero.greeting': 'INGENIERO DE DESPLIEGUE AVANZADO',
    'hero.name': 'JUAN FABRICIO AGUIRRE TAMAYO',
    'hero.tagline': 'Uniendo inteligencia biológica con inteligencia artificial',
    'hero.scroll': 'DESPLÁZATE PARA EXPLORAR',

    // Thought Process
    'thoughts.title': 'PROCESO DE PENSAMIENTO',
    'thoughts.subtitle': 'Una vida de habilidades convergiendo en una visión singular',
    'thoughts.prompt': 'Ingeniería de Prompts',
    'thoughts.agri': 'Ingeniería Agrícola',
    'thoughts.drone': 'Piloto de Drones',
    'thoughts.sales': 'Ventas Generales',
    'thoughts.hockey': 'Jugador de Hockey',
    'thoughts.skating': 'Entrenador de Patinaje',
    'thoughts.ai': 'Desarrollo IA y Agentes LLM',
    'thoughts.mcp': 'Arquitectura MCP',
    'thoughts.react': 'React + Vite',
    'thoughts.python': 'Python',
    'thoughts.web': 'HTML, CSS, JS',
    'thoughts.php': 'PHP',
    'thoughts.git': 'Git Avanzado',

    // Character Journey
    'journey.title': 'EL VIAJE',
    'journey.field': 'En los campos de Ecuador, aprendiendo a nutrir la vida',
    'journey.drone': 'Tomando vuelo - 500+ horas de operaciones con drones',
    'journey.sales': 'Dominando el arte de la conexión humana en ventas',
    'journey.hockey': 'Disciplina y trabajo en equipo sobre el hielo',
    'journey.skating': 'Enseñando a otros a encontrar su equilibrio',
    'journey.code': 'Traduciendo patrones biológicos a código',
    'journey.ai': 'Arquitectando el futuro con agentes de IA',

    // Skills
    'skills.title': 'ARSENAL TÉCNICO',
    'skills.categories.life': 'Habilidades de Vida',
    'skills.categories.tech': 'Habilidades Técnicas',
    'skills.categories.ai': 'IA y Stack Moderno',

    // Projects
    'projects.title': 'ESTUDIOS DE CASO',
    'projects.subtitle': 'Aplicaciones reales resolviendo problemas reales',
    'projects.view': 'Ver Proyecto',
    'projects.code': 'Ver Código',
    'projects.demo': 'Demo en Vivo',
    'projects.featured': 'Destacado',

    // Contact
    'contact.title': 'ESTABLECER CONEXIÓN',
    'contact.subtitle': 'Listo para construir algo extraordinario juntos',
    'contact.email': 'Correo',
    'contact.github': 'GitHub',
    'contact.linkedin': 'LinkedIn',
    'contact.whatsapp': 'WhatsApp',
    'contact.message': 'Colaboremos',

    // Footer
    'footer.rights': 'Todos los derechos reservados',
    'footer.built': 'Construido con precisión y pasión',

    // Language
    'lang.switch': 'EN',
    'lang.current': 'ES',
  },
};

export function getTranslation(locale: Locale, key: string): string {
  return translations[locale][key] || key;
}